<div class=" header bg-primary pb-6">

    <div class=" container-fluid">
      <div class=" header-body">
        <div class=" row align-items-center py-4">
          <div class=" col-lg-6 col-7">
            <h6 class=" h2 text-white d-inline-block mb-0">Payment Methods</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  
  <div class=" container-fluid mt--6">
    
    <div *ngIf="loading" class="row">
      <app-shimmer class=" col-xl-3 col-md-6" *ngFor="let item of shimmerArray"></app-shimmer>
  
    </div>
    <div *ngIf="!loading" class="row">
  
      <app-card class=" col-xl-3 col-md-6" *ngFor="let Payment of PaymentMethodArray"
        (deleteSubmitHandler)="onDeleteHandler($event)" [id]="Payment.id" [cardTitle]="Payment.Paymentmethod"
        [cardHeadline]="'Payment Method'" [editUrl]="'edit'" [loading]="loading"></app-card>
    </div>
  </div>
  
  
  <div class="fab-btn" [routerLink]="'add'">
    <i class="ni ni-fat-add"></i>
  </div>
  